import type { SxProps, Theme } from '@mui/material';
import { Box, Chip, Drawer, TableCell, Typography, styled } from '@mui/material';
import type { FC, InputHTMLAttributes, ReactNode } from 'react';
import { memo } from 'react';
import { useFormContext } from 'react-hook-form';

interface MetricInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'name'> {
  name: string;
}

export const MetricInput = memo(({ name, style, ...restProps }: MetricInputProps) => {
  const { register } = useFormContext();

  return (
    <input
      {...restProps}
      {...register(name)}
      style={{
        border: '1px solid rgb(224, 224, 224)',
        borderRadius: 12,
        fontSize: '0.875rem',
        ...style,
      }}
    />
  );
});
export const MetricChip = memo(({ label, sx }: { label: string; sx?: SxProps<Theme> }) => (
  <Chip
    sx={{
      '&': {
        height: 32,
      },
      '& .MuiChip-label': {
        display: 'inline-block',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        maxWidth: 300,
      },
    }}
    label={label}
  />
));

const MetricsEmptyState = () => {
  return (
    <Box sx={{ flex: 1, flexGrow: 1, display: 'flex', height: '100%', alignItems: 'center', justifyContent: 'center' }}>
      <Typography>Data not received</Typography>
    </Box>
  );
};

interface MetricDrawerProps {
  open: boolean;
  onClose: () => void;
  children?: ReactNode;
}
export const MetricDrawer: FC<MetricDrawerProps> = ({ open, onClose, children }): ReactNode => (
  <Drawer
    anchor={'right'}
    open={open}
    onClose={onClose}
    PaperProps={{ sx: { width: '100%', maxWidth: 500, px: 2.5, py: 3, boxShadow: 'none' } }}
  >
    {children}
  </Drawer>
);

export const TableCellStickyStyled = styled(TableCell)(() => ({
  position: 'sticky',
  top: 0,
  zIndex: 4,
}));

export default MetricsEmptyState;
